export function initDetailGrid($) {
    $(".detail-grid.detail-grid-inline").each(function (n, el) {
        let $items = $(".detail-grid-item", el);

        $items.each(function (n, item) {

			// Move the detail content to the end of the grid item
			var color = $(item).css('background-color');
			var $detail = $(".detail-grid-item-detail", item);
			$detail.css('border-color', color);

            // Move the detail content to the end of the grid item
            $(el).after($detail);

            $(item).on("click", function (e) {
                e.preventDefault();
                toggleActiveClass($, el, item);
            });
        });
    });
}

function toggleActiveClass($, grid, item) {
    // if grid is not active, activate it and the item
    if (!grid.classList.contains("active")) {
        toggleGrid($, grid);
        toggleItem($, item, grid);
    }
    // if grid is already active
    else {
        toggleItem($, item, grid);
    }
}

function toggleGrid($, grid) {
    if (!document.startViewTransition) {
        // view transitions not supported, just toggle the class
        grid.classList.toggle("active");
    } else {
        // view transitions supported! now they animate 8-)
        document.startViewTransition(() => grid.classList.toggle("active"));
    }
}

function toggleItem($, item, grid) {
	let items = $(".detail-grid-item", item.parentElement);

    if (item.classList.contains("active")) {
        item.classList.remove("active");

		$(items).each(function (n, el) {
            el.classList.remove("active");
			var target = el.getAttribute("data-bs-target");
            $(target).removeClass("show");
        });

        toggleGrid($, grid);
    } else {
        // remove active class from all items except current
        $(items).not(item).each(function (n, el) {
            el.classList.remove("active");
			var target = el.getAttribute("data-bs-target");
            $(target).removeClass("show");
        });

		var target = item.getAttribute("data-bs-target");
        item.classList.add("active");
		$(target).addClass("show");

		// scroll target into viewport if the viewport is less than 600 wide
		var $target = $(target);
		if ($target.length && $(window).width() < 600){
			$('html, body').animate({
				scrollTop: $target.offset().top - 100
			}, 500);
		}
    }
}